<template>
  <div style="width: 120px">
    <el-input v-model="rate"
              :disabled="disabled"
              @focus="onfocus"
              @blur="onblur"
              size="small"><template slot="append">%</template></el-input>
  </div>
</template>
<script>
import LibProductItem from '../../../minxin/ProductItem';

export default {
  name: "ProductItemTypeRate",
  mixins: [LibProductItem],
  props: {
    value: Number
  },
  data() {
    return {
      rate: this.parseRate(this.value)
    }
  },
  methods: {
    onfocus() {
      this.rate = this.parseRate(this.value)
    },
    onblur() {
      let n = this.rate
      if (/^\d{0,6}(\.\d{0,9})?$/.exec(n) !== null) {
        if (n === "") {
          n = null
        } else {
          n = Math.round((parseFloat(n) || 0) / 100 * 1000000) / 1000000
        }

        this.$emit('input', n)
        this.rate = this.parseRate(n)
      } else {
        this.rate = this.parseRate(this.value)
      }
    },

    parseRate(r) {
      if (r !== null && r !== undefined) {
        r = Math.round(r * 100000000) / 1000000
      }

      return r
    }
  }
}
</script>
